var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_148_308",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 36,
    height: 36,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -1,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0312 15.0312V18.9688H8.65625L19.8125 30.2188L17 33.0312L0.96875 17L17 0.96875L19.8125 3.78125L8.65625 15.0312H33.0312Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0312 15.0312V18.9688H8.65625L19.8125 30.2188L17 33.0312L0.96875 17L17 0.96875L19.8125 3.78125L8.65625 15.0312H33.0312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0312 15.0312H34.0312V14.0312H33.0312V15.0312ZM33.0312 18.9688V19.9688H34.0312V18.9688H33.0312ZM8.65625 18.9688V17.9688H6.25625L7.94619 19.6729L8.65625 18.9688ZM19.8125 30.2188L20.5196 30.9259L21.2238 30.2217L20.5226 29.5146L19.8125 30.2188ZM17 33.0312L16.2929 33.7384L17 34.4455L17.7071 33.7384L17 33.0312ZM0.96875 17L0.261643 16.2929L-0.445464 17L0.261643 17.7071L0.96875 17ZM17 0.96875L17.7071 0.261643L17 -0.445464L16.2929 0.261643L17 0.96875ZM19.8125 3.78125L20.5226 4.48539L21.2238 3.7783L20.5196 3.07414L19.8125 3.78125ZM8.65625 15.0312L7.94619 14.3271L6.25625 16.0312H8.65625V15.0312ZM32.0312 15.0312V18.9688H34.0312V15.0312H32.0312ZM33.0312 17.9688H8.65625V19.9688H33.0312V17.9688ZM7.94619 19.6729L19.1024 30.9229L20.5226 29.5146L9.36631 18.2646L7.94619 19.6729ZM19.1054 29.5116L16.2929 32.3241L17.7071 33.7384L20.5196 30.9259L19.1054 29.5116ZM17.7071 32.3241L1.67586 16.2929L0.261643 17.7071L16.2929 33.7384L17.7071 32.3241ZM1.67586 17.7071L17.7071 1.67586L16.2929 0.261643L0.261643 16.2929L1.67586 17.7071ZM16.2929 1.67586L19.1054 4.48836L20.5196 3.07414L17.7071 0.261643L16.2929 1.67586ZM19.1024 3.07711L7.94619 14.3271L9.36631 15.7354L20.5226 4.48539L19.1024 3.07711ZM8.65625 16.0312H33.0312V14.0312H8.65625V16.0312Z",
    fill: "black",
    mask: "url(#path-1-outside-1_148_308)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.c171228899b076dc337549468eed811c.svg";
export { ForwardRef as ReactComponent };